export const onlyDigits = (value: string): string => (value ?? "").replace(/\D/g, "");

export const isAllSameDigit = (value: string): boolean => /^(\d)\1+$/.test(value);

/**
 * Gera um identificador estável para uso no frontend mesmo fora de contexto seguro.
 */
export function generateRandomId(): string {
	const randomUUID = globalThis.crypto?.randomUUID;

	if (typeof randomUUID === "function") return randomUUID.call(globalThis.crypto);

	return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
